import { useState, MouseEvent } from "react";
import { IconButton, Menu, MenuItem, ListItemText } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";

export const AccountMenu = (props: { email?: string; onSignOut: () => void }) => {
  const { email, onSignOut } = props;
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <>
      <IconButton
        onClick={(e: MouseEvent<HTMLElement>) => setAnchorEl(e.currentTarget)}
        style={{ color: "white" }}
        aria-label="Account menu"
      >
        <AccountCircleIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        {/* The account's email, moved here from the always-visible header
            button - shown as a disabled header row rather than a clickable
            item, above Sign Out. */}
        {email && (
          <MenuItem disabled divider>
            <ListItemText>{email}</ListItemText>
          </MenuItem>
        )}
        <MenuItem component={RouterLink} to="/billing" onClick={() => setAnchorEl(null)}>
          <ListItemText>Billing</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            onSignOut();
          }}
        >
          <ListItemText>Sign Out</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};

export default AccountMenu;
